// 五一爆料 · 单页内容数据（静态展示，可后续替换为真实数据源）

export interface NewsItem {
  id: string;
  category: string;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  time: string;
  image: string;
}

export const featuredNews: NewsItem[] = [
  {
    id: 'f1',
    category: '旅行',
    tag: '出行大瓜',
    title: '高速出口大排长龙，"最后一百米"堵成停车场',
    summary:
      '五一假期首日，多个城市高速与景区周边路段出现集中缓行，导航地图上一片"姨妈红"。有人调侃堵车也是假期的一部分，也有人晒出在车流里野餐、拍短视频打发时间的名场面，意外催生一批"堵车文学"。',
    heat: '328.6万',
    time: '05-01 12:40',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20isometric%20illustration%20of%20a%20highway%20jammed%20with%20colorful%20cars%20stretching%20to%20the%20horizon%20under%20a%20sunny%20spring%20sky%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20cartoon%20style%2C%20clean%20and%20minimal%20composition&width=1600&height=900&seq=f1-highway&orientation=landscape',
  },
  {
    id: 'f2',
    category: '文旅',
    tag: '景区名场面',
    title: '网红打卡地游客爆棚，热门街区上演"人从众"',
    summary:
      '假期景区持续升温，热门步行街与古镇一度开启限流模式。网友镜头里，地标前被层层人群包围，却依然挡不住大家拍照的热情，还有人总结出"最佳拍摄位"与错峰攻略，把拥挤也玩成了集体狂欢。',
    heat: '261.2万',
    time: '05-01 09:15',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20bustling%20ancient%20town%20street%20filled%20with%20crowds%20carrying%20flags%20and%20balloons%20under%20hanging%20lanterns%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style%2C%20lively%20festive%20mood&width=1600&height=900&seq=f2-crowd&orientation=landscape',
  },
  {
    id: 'f3',
    category: '娱乐',
    tag: '银幕话题',
    title: '五一档电影口碑两极，网友为"值不值"吵翻',
    summary:
      '五一档多部新片同日上映，题材涵盖喜剧、动作与合家欢。首日票房出炉后口碑出现明显分化，有人直呼"票价值了"，也有人调侃踩雷。围绕剧情、演技与特效的热议持续刷屏，"年度第一场电影票到底该给谁"成了朋友群的热门选择题。',
    heat: '214.5万',
    time: '05-01 20:05',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20cozy%20cinema%20screen%20showing%20a%20vibrant%20film%20poster%2C%20popcorn%20and%20soda%20cups%20in%20the%20foreground%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20illustration%20style&width=1600&height=900&seq=f3-cinema&orientation=landscape',
  },
];

export const newsList: NewsItem[] = [
  {
    id: 'n1',
    category: '民生',
    tag: '假期服务',
    title: '车站增设"快闪"志愿服务点，老人也能顺畅出行',
    summary:
      '假期首日，多个主要车站与机场在人流密集处增设临时指引点，协助购票、指路与行李搬运，不少带娃出行的家庭直呼"太贴心"。出行服务持续升级的同时，错峰乘车的建议也再度被网友点赞。',
    heat: '186.3万',
    time: '05-01 15:30',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20bright%20train%20station%20with%20kind%20staff%20helping%20travelers%20with%20luggage%20and%20tickets%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style%2C%20clean%20minimal%20composition&width=900&height=600&seq=n1-service&orientation=landscape',
  },
  {
    id: 'n2',
    category: '娱乐',
    tag: '音乐节',
    title: '户外音乐节热力全开，台上台下一起"蹦起来"',
    summary:
      '多个城市在小长假举办主题音乐节，舞台前从傍晚嗨到深夜。现场观众晒出的挥手灯光海刷爆短视频，散场后"耳朵还在嗡嗡响"的自嘲也让没到场的人隔着屏幕都能感受到气氛。',
    heat: '158.9万',
    time: '05-01 22:10',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20an%20open%20air%20music%20festival%20stage%20with%20colorful%20stage%20lights%20and%20a%20joyful%20crowd%20raising%20hands%20under%20the%20evening%20sky%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style&width=900&height=600&seq=n2-music&orientation=landscape',
  },
  {
    id: 'n3',
    category: '文旅',
    tag: '城市漫游',
    title: 'City Walk 再升温，游客爱上"用脚丈量城市"',
    summary:
      '比起赶景点，越来越多人在假期选择钻进街巷来一场随性漫步，找一家小馆、探一条老街、看一场日落。城市漫步话题热度走高，"去哪里不重要，走走停停就很治愈"成了不少人的假期共识。',
    heat: '143.2万',
    time: '05-01 18:45',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20person%20strolling%20through%20a%20charming%20old%20city%20lane%20with%20small%20shops%2C%20plants%20and%20cozy%20cafes%2C%20sunset%20light%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style&width=900&height=600&seq=n3-citywalk&orientation=landscape',
  },
  {
    id: 'n4',
    category: '民生',
    tag: '返程提醒',
    title: '假期过半返程高峰将至，这份出行小贴士请收好',
    summary:
      '随着假期进入后半段，返程车流与人流开始增多。多个平台陆续发布错峰建议与天气提示，提醒大家提前规划路线、预留充足时间。评论区里，网友开始互相分享"如何优雅避开堵车"的实战经验。',
    heat: '131.6万',
    time: '05-02 10:00',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20bus%20train%20and%20car%20moving%20on%20a%20sunset%20highway%20with%20road%20signs%2C%20return%20journey%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style&width=900&height=600&seq=n4-return&orientation=landscape',
  },
  {
    id: 'n5',
    category: '网络',
    tag: '热梗潮',
    title: '"特种兵式打卡"冲上热搜，年轻人挑战一天逛N地',
    summary:
      '假期里兴起一股"特种兵式旅游"玩法，有人用一天串起多个景点与美食点，晒出密密麻麻的路线图与步数记录。高效与刺激并存的话题引发共鸣，也让"假期到底该躺还是该冲"成为一道无标准答案的选择题。',
    heat: '120.8万',
    time: '05-02 16:20',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20young%20traveler%20with%20a%20backpack%20and%20phone%20checking%20off%20many%20landmark%20spots%20on%20a%20route%20map%2C%20energetic%20spring%20travel%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style&width=900&height=600&seq=n5-special&orientation=landscape',
  },
  {
    id: 'n6',
    category: '文旅',
    tag: '打卡新宠',
    title: '县域小城逆袭成"宝藏目的地"，反向旅游正当时',
    summary:
      '避开人挤人的热门景区，一批交通便利、美食地道的县域小城在假期迎来明显客流增长。游客晒出的烟火气画面圈粉无数，"反向旅游"概念持续走热，小城里的地道小吃店门口排起长队。',
    heat: '112.4万',
    time: '05-02 19:55',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20cozy%20small%20county%20town%20with%20street%20food%20stalls%2C%20steaming%20snacks%20and%20friendly%20crowds%2C%20spring%20travel%20discovery%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20playful%20flat%20cartoon%20style&width=900&height=600&seq=n6-county&orientation=landscape',
  },
];

// 话题热榜：分类 + 榜单条目
export const hotCategories = ['全部', '出行', '文旅', '娱乐', '民生'];

export interface HotRankItem {
  rank: number;
  title: string;
  tag: string;
  hot: number;
  trend: 'up' | 'down' | 'same';
}

export interface HotCategoryData {
  category: string;
  items: HotRankItem[];
}

export const hotRankByCategory: HotCategoryData[] = [
  {
    category: '全部',
    items: [
      { rank: 1, title: '五一假期首日多地高速现集中车流', tag: '出行', hot: 328.6, trend: 'up' },
      { rank: 2, title: '热门景区限流，网红街区开启错峰提示', tag: '文旅', hot: 261.2, trend: 'up' },
      { rank: 3, title: '五一档电影口碑两极引热议', tag: '娱乐', hot: 214.5, trend: 'up' },
      { rank: 4, title: '户外音乐节人气爆棚嗨到深夜', tag: '娱乐', hot: 158.9, trend: 'same' },
      { rank: 5, title: '车站志愿服务点助顺畅出行', tag: '民生', hot: 186.3, trend: 'up' },
      { rank: 6, title: '返程高峰将至，错峰建议刷屏', tag: '民生', hot: 131.6, trend: 'up' },
      { rank: 7, title: 'City Walk 假期漫游持续升温', tag: '文旅', hot: 143.2, trend: 'down' },
      { rank: 8, title: '特种兵式打卡挑战一天逛N地', tag: '网络', hot: 120.8, trend: 'up' },
    ],
  },
  {
    category: '出行',
    items: [
      { rank: 1, title: '假期首日高速出口现大排长龙', tag: '出行', hot: 328.6, trend: 'up' },
      { rank: 2, title: '铁路客流创新高，热门区间加开临客', tag: '出行', hot: 198.7, trend: 'up' },
      { rank: 3, title: '返程高峰天气预报提醒提前规划', tag: '出行', hot: 165.3, trend: 'up' },
      { rank: 4, title: '机场安检提速，值机流程再优化', tag: '出行', hot: 142.0, trend: 'same' },
      { rank: 5, title: '景区摆渡车免费接驳获点赞', tag: '出行', hot: 118.9, trend: 'down' },
    ],
  },
  {
    category: '文旅',
    items: [
      { rank: 1, title: '网红街区游客爆棚开启限流', tag: '文旅', hot: 261.2, trend: 'up' },
      { rank: 2, title: 'City Walk 城市漫游热度走高', tag: '文旅', hot: 143.2, trend: 'down' },
      { rank: 3, title: '县域小城成宝藏目的地', tag: '文旅', hot: 112.4, trend: 'up' },
      { rank: 4, title: '博物馆预约爆满，研学游走俏', tag: '文旅', hot: 98.6, trend: 'up' },
      { rank: 5, title: '夜间灯光秀点亮城市地标', tag: '文旅', hot: 87.1, trend: 'same' },
    ],
  },
  {
    category: '娱乐',
    items: [
      { rank: 1, title: '五一档电影口碑两极引热议', tag: '娱乐', hot: 214.5, trend: 'up' },
      { rank: 2, title: '户外音乐节嗨到深夜', tag: '娱乐', hot: 158.9, trend: 'same' },
      { rank: 3, title: '古装剧定档五一，网友疯狂蹲守', tag: '娱乐', hot: 139.4, trend: 'up' },
      { rank: 4, title: '综艺节目假期特辑上线', tag: '娱乐', hot: 104.7, trend: 'down' },
      { rank: 5, title: '明星云集音乐节路透刷屏', tag: '娱乐', hot: 96.2, trend: 'same' },
    ],
  },
  {
    category: '民生',
    items: [
      { rank: 1, title: '车站志愿服务点助老人顺畅出行', tag: '民生', hot: 186.3, trend: 'up' },
      { rank: 2, title: '假期食品安全检查守护舌尖', tag: '民生', hot: 152.8, trend: 'up' },
      { rank: 3, title: '热门商圈延时营业丰富夜生活', tag: '民生', hot: 137.5, trend: 'same' },
      { rank: 4, title: '假期消费券发放助力买买买', tag: '民生', hot: 121.9, trend: 'down' },
      { rank: 5, title: '天气多变，外出注意增减衣物', tag: '民生', hot: 108.3, trend: 'up' },
    ],
  },
];

// 热梗盘点
export interface MemeItem {
  id: string;
  word: string;
  meaning: string;
  source: string;
  color: 'primary' | 'accent' | 'secondary';
  image: string;
}

export const memeList: MemeItem[] = [
  {
    id: 'm1',
    word: '堵车文学',
    meaning: '把堵在路上的烦躁写成段子：从"此处风景独好"到"已下单车边野餐"，凡尔赛式记录返程与出游的漫长车程。',
    source: '源自高速车流现场分享',
    color: 'primary',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20person%20writing%20in%20a%20notebook%20inside%20a%20car%20stuck%20in%20traffic%20on%20a%20highway%2C%20playful%20comedic%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m1-duche&orientation=squarish',
  },
  {
    id: 'm2',
    word: '人从众',
    meaning: '景区人挤人的戏称：单人一个"人"，人多成"从"，更多人就成"众"，一眼看过去全是后脑勺的假期标配。',
    source: '景区实况热评',
    color: 'accent',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20many%20overlapping%20crowd%20heads%20at%20a%20tourist%20spot%2C%20funny%20dense%20crowd%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m2-rencongzhong&orientation=squarish',
  },
  {
    id: 'm3',
    word: '特种兵式打卡',
    meaning: '用最短时间刷最多地点的极限玩法：一天串起数个景点与美食点，路线规划得像军事行动一样精准高效。',
    source: '年轻游客自发玩法',
    color: 'secondary',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20determined%20young%20backpacker%20with%20a%20route%20map%20and%20snacks%20moving%20fast%20between%20landmarks%2C%20energetic%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m3-tezhong&orientation=squarish',
  },
  {
    id: 'm4',
    word: '反向旅游',
    meaning: '避开人挤人的热门景区，转而奔向宝藏小城与冷门目的地，花更少的钱、排更短的队，享受真正的烟火气。',
    source: '年轻人出行新风向',
    color: 'accent',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20relaxed%20traveler%20enjoying%20quiet%20street%20food%20in%20a%20cozy%20small%20town%2C%20off%20the%20beaten%20path%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m4-fanxiang&orientation=squarish',
  },
  {
    id: 'm5',
    word: '宅家快乐水',
    meaning: '不凑热闹的假期打开方式：窝在家里追剧、打游戏、点外卖，用一杯快乐水和一份爆米花承包整个小长假。',
    source: '宅家派假期宣言',
    color: 'primary',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20cozy%20person%20relaxing%20on%20a%20sofa%20watching%20tv%20with%20popcorn%20and%20a%20soda%20on%20the%20coffee%20table%2C%20cozy%20stay%20at%20home%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m5-zhaijia&orientation=squarish',
  },
  {
    id: 'm6',
    word: '假期余额不足',
    meaning: '假期进入尾声的灵魂拷问：眼看清零的不仅是假期，还有那颗还没玩够的心，"余额不足"成为返程路上的集体心声。',
    source: '返程季常见热梗',
    color: 'secondary',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20clock%20and%20calendar%20showing%20the%20last%20day%20of%20a%20holiday%20with%20a%20melancholy%20but%20playful%20mood%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=800&height=800&seq=m6-yue&orientation=squarish',
  },
];

// 假期现场见闻
export interface SceneItem {
  id: string;
  place: string;
  title: string;
  blurb: string;
  author: string;
  image: string;
}

export const sceneList: SceneItem[] = [
  {
    id: 's1',
    place: '杭州·西湖',
    title: '清晨六点的断桥人少景美，走完一圈才懂什么叫"人间烟火"',
    blurb:
      '避开人潮赶了个早，晨光里的湖面像镀了金。偶遇晨练大爷热情指路，推荐的本地小面馆成了今天的高光，排长队也值。',
    author: '阿茶不吃香菜',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20calm%20lake%20with%20a%20stone%20bridge%20at%20dawn%2C%20golden%20morning%20light%20over%20water%2C%20peaceful%20spring%20scene%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=900&height=600&seq=s1-xihu&orientation=landscape',
  },
  {
    id: 's2',
    place: '长沙·五一广场',
    title: '夜宵江湖凌晨依旧火热，一碗粉下肚直接复活',
    blurb:
      '凌晨一点的长沙比白天还热闹，油亮的米粉配着现炒码子，辣得冒汗也停不下筷。隔壁桌大哥一边嗦粉一边给我们划了三条美食路线，太有用了。',
    author: '干饭第一名',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20lively%20late%20night%20food%20street%20in%20changsha%20with%20steaming%20noodle%20bowls%20and%20neon%20signs%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=900&height=600&seq=s2-changsha&orientation=landscape',
  },
  {
    id: 's3',
    place: '成都·宽窄巷子',
    title: '人潮里的"慢生活"：找条支巷坐下，一下午就过去了',
    blurb:
      '主巷被人流填满，拐进支巷却别有洞天。树荫下的竹椅、盖碗茶和慢悠悠的川剧变脸，让人忽然懂了什么叫"来都来了，先喝杯茶再说"。',
    author: '香菜不要行',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20shady%20old%20lane%20in%20chengdu%20with%20bamboo%20chairs%20tea%20and%20a%20sichuan%20opera%20mask%2C%20relaxed%20slow%20living%20theme%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=900&height=600&seq=s3-chengdu&orientation=landscape',
  },
  {
    id: 's4',
    place: '苏州·平江路',
    title: '摇橹船划过水巷，评弹声里闻到初夏的味道',
    blurb:
      '乘船穿过老城水巷，两岸白墙黛瓦缓缓后退。船娘的吴侬软语配上评弹小调，节奏慢到让人忘了时间，这就是"烟雨江南"的模样吧。',
    author: '晚风很温柔',
    image:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20traditional%20suzhou%20canal%20with%20white%20walls%20and%20dark%20tiled%20roofs%2C%20a%20rowing%20boat%20on%20the%20water%2C%20spring%20scene%2C%20tangerine%20orange%20and%20fresh%20green%20melon%20color%20palette%2C%20soft%20cream%20background%2C%20clean%20flat%20cartoon%20style&width=900&height=600&seq=s4-suzhou&orientation=landscape',
  },
];

// FAQ（需与 index.html FAQPage 结构化数据保持一致）
export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: '五一爆料收录的热点事件来自哪里？',
    a: '五一爆料汇总的范围包括各大社交平台的热搜话题、资讯榜单与网友现场分享，我们会筛选最具讨论度的内容，按事件热度、话题属性与时间顺序进行盘点整理，方便你快速抓住假期重点。',
  },
  {
    q: '榜单中的热度排名是怎么来的？',
    a: '话题热榜综合参考讨论量、阅读量、互动次数与持续热度四项维度加权排序，反映五一假期期间公众关注度较高的话题，帮你判断哪些瓜值得一吃。',
  },
  {
    q: '为什么有些话题刷到过但榜上没有？',
    a: '假期话题更新极快，榜单会随时间滚动更新。我们保留一段时间内讨论持续性较高的话题，纯瞬时流量、缺少持续发酵的话题可能不会长期停留，属正常现象。',
  },
  {
    q: '可以投稿自己发现的假期热点吗？',
    a: '当然可以。如果你在假期中看到有趣或有价值的现场见闻，欢迎通过底部联系方式向我们投稿，经核实整理后会补录进对应盘点栏目，一起把好瓜分享给更多人。',
  },
  {
    q: '需要注册账号才能使用吗？',
    a: '不需要。五一爆料为开放浏览的资讯站，无需注册或登录即可查看全部热点、热榜、热梗与现场内容，随开随看，轻松吃瓜不迷路。',
  },
];